import React, {useEffect,useReducer} from 'react'
import axios from "axios";

const BASE_URL="https://cors-anywhere.herokuapp.com/https://jobs.github.com/positions.json/"

const ACTIONS={
    MAKE_REQUEST:"make-request",
    GET_DATA:"get-data",
    ERROR: "error",
    UPDATE_HAS_NEXT_PAGE:"update-has-next-page",
}

function reducer(state,action){
    switch(action.type){
        case ACTIONS.MAKE_REQUEST:
            return{loading:true,jobs:[]}
        case ACTIONS.GET_DATA:
            return {...state,loading:false,jobs:action.payload.jobs}
        case ACTIONS.ERROR:
            return {...state,loading:false,jobs:[],error:action.payload.error}
        case ACTIONS.UPDATE_HAS_NEXT_PAGE:
            return {...state ,hasNextPage:action.payload.hasNextPage }
        default: return state
    }
}

export default function useFetchJobs(params,page){
    const [state,dispatch]=useReducer(reducer,{jobs:[],loading:true});
    useEffect(()=>{
        //Cancelling the token
        const cancelToken1=axios.CancelToken.source();
        const cancelToken2=axios.CancelToken.source();
        
        dispatch({type:ACTIONS.MAKE_REQUEST});
        
        //Calling the API to fetch the jobs
        axios.get(BASE_URL, {
            cancelToken1:cancelToken1.source,
            params:{markdown:true,page:page,...params}
        }).then((res)=>{
            dispatch({type:ACTIONS.GET_DATA,payload:{jobs:res.data}})
        })
        .catch((e)=>{
            if(axios.isCancel(e)) return;
            dispatch({type:ACTIONS.ERROR,payload:{error:e}});
        })

        //Calling the API again to check if the next page exists
            axios.get(BASE_URL,{
            cancelToken2:cancelToken2.source,
            params:{markdown:true,page:page+1,...params}
        }).then((res)=>{
            dispatch({ type: ACTIONS.UPDATE_HAS_NEXT_PAGE, payload: { hasNextPage: (res.data.length > 0) } })
        })
        .catch((e)=>{
            if(axios.isCancel(e)) return;
            dispatch({type:ACTIONS.ERROR,payload:{error:e}});
        })

        //Cancelling the token
        return()=>{
            cancelToken1.cancel();
            cancelToken2.cancel();
        }

    },[params,page])
    return state;
}